import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=9b81c8bc&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
import style0 from "./base.scss?vue&type=style&index=0&id=9b81c8bc&prod&scoped=true&lang=scss&external"
import style1 from "./Base.vue?vue&type=style&index=1&id=9b81c8bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b81c8bc",
  null
  
)

export default component.exports